import { axiosClient } from "../client";

const queryString = require("query-string");

const OFFERS_INFO_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/offers`;

const DISCOUNT_INFO_UPDATE_ALL = (locationId, discountOptionId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/discount/${discountOptionId}`;

const OFFERS_INFO_CREATE = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/offers`;

const OFFERS_INFO_UPDATE = (locationId, offerId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/offers/${offerId}`;

const DISCOUNT_INFO_DELETE = (locationId, discountOptionId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/discount/${discountOptionId}`;

export const fetchAllOffersInfo = (locationId) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: OFFERS_INFO_GET_ALL(locationId),
        // query: { sort: ["created", "ASC"] },
      },
      { arrayFormat: "comma" },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const updateDiscountInfo = (
  locationId,
  discountOptionId,
  data,
  body,
  logAppName,
) =>
  axiosClient({
    method: "PUT",
    url: DISCOUNT_INFO_UPDATE_ALL(locationId, discountOptionId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
    body,
    logAppName,
    locationId,
  });

export const createOfferInfo = (locationId, data, body, logAppName) =>
  axiosClient({
    method: "POST",
    url: OFFERS_INFO_CREATE(locationId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
    body,
    logAppName,
    locationId,
  });

  export const updateOfferInfo = (locationId, data, offerId, body, logAppName) =>
  axiosClient({
    method: "PUT",
    url: OFFERS_INFO_UPDATE(locationId, offerId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
    body,
    logAppName,
    locationId,
  });

export const deleteDiscountInfo = (
  locationId,
  discountOptionId,
  body,
  logAppName,
) =>
  axiosClient({
    method: "DELETE",
    url: DISCOUNT_INFO_DELETE(locationId, discountOptionId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
    body,
    logAppName,
    locationId,
  });
